var React = require('react');

function Desktop (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"5","y":"5","width":"22","height":"16","rx":"1","stroke":"currentColor","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M5 17L27 17","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","key":1}),React.createElement("rect",{"x":"10","y":"26","width":"12","height":"2","rx":"1","fill":"currentColor","key":2}),React.createElement("rect",{"x":"13","y":"22","width":"2","height":"6","fill":"currentColor","key":3}),React.createElement("rect",{"x":"17","y":"22","width":"2","height":"6","fill":"currentColor","key":4})]);
}

Desktop.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Desktop;

Desktop.default = Desktop;
